import {
    Skeleton as UiSkeleton,
    Typography as UiTypography,
    styled,
    styledForMobile,
} from "@l2r-front/l2r-ui"

export const Skeleton = styled(UiSkeleton)({
    height: 24,
    transform: "scale(1)",
    width: 220,
})

export const RoadDetailWrapper = styled("div")(({ theme }) => ({
    padding: theme.spacing(0, 8, 8, 8),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
    marginTop: theme.spacing(5),
}))

export const Wrapper = styledForMobile("div")(({ isMobile, theme }) => ({
    backgroundColor: theme.palette["common/gray_states"].light,
    flex: 1,
    height: "fit-content",
    padding: theme.spacing(isMobile ? 5 : 8),
}))

export const Container = styled("div")(() => ({
    display: "flex",
    flex: 1,
    flexDirection: "column",
    height: "100%",
}))

export const ErrorText = styled(UiTypography)(({ theme }) => ({
    color: theme.palette["error"].main,
    marginTop: theme.spacing(5),
}))
